import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import axios from "axios";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Card,
  CardImg,
  CardText,
  CardBody,
  CardTitle,
  CardSubtitle,
  CardHeader,
  Button,
  Alert,
  InputGroupAddon,
  InputGroup
} from "reactstrap";
import moment from "moment";
import classNames from "classnames";
import propTypes from "prop-types";
import styled from "styled-components";

import { API_BASE_URL } from "../../constants/index";
import { TextRupiah } from "../Text";
import {
  ADMINISTRATOR,
  APPROVED,
  SUSPEND,
  REJECTED,
  UNDER_REVIEW,
  WAIT_CONFIRM,
  WAIT_CONSIGN,
  CANCELLED,
  DRAFT,
  MORE_INFO,
  SEMPURNA,
  CACAT,
  NO_BOX,
  BARU,
  BEKAS,
  LISTING,
  emptyImage,
  convertToRupiah,
  getCloudImageUrl
} from "../../utils";
import ReactLoading from "react-loading";
import { getCacheImage } from "../../config";
import _ from "lodash";

import CloseIcon from "../../images/close-button-search.png";
import emptySneakerImg from "../../images/emptysneakers2.png";
import { normalizeBrand } from "../../utils/Helpers";

const defectCondition = (bool, userSell, saleProduct) => {
  if (saleProduct !== undefined) {
    switch (bool) {
      case true:
        return detailCondition(userSell, saleProduct.size);
      case false:
        return (
          <ButtonWrapper>
            <Button className="btn-black flat">
              US {saleProduct && saleProduct.size.US}
            </Button>
            <Button className="btn-black flat">
              {infoString(saleProduct && saleProduct.sneakers_condition)}
            </Button>
            <Button className="btn-black flat">Perfect Condition</Button>
          </ButtonWrapper>
        );

      default:
        return (
          <ButtonWrapper>
            <Button className="btn-black flat">
              US {saleProduct && saleProduct.size.US}
            </Button>
            <Button className="btn-black flat">
              {infoString(saleProduct && saleProduct.sneakers_condition)}
            </Button>
            <Button className="btn-black flat">Perfect Condition</Button>
          </ButtonWrapper>
        );
    }
  }
};

const detailCondition = (data, size) => {
  const condition = data.defects.filter(item => item.value);

  return (
    <ButtonWrapper>
      <Button className="btn-black flat" style={{ cursor: "default" }}>
        US {size.US}
      </Button>
      <Button className="btn-black flat" style={{ cursor: "default" }}>
        {infoString(data.sneakers_condition)}
      </Button>
      {condition.map((data, index) => {
        return (
          <Button
            key={index}
            className="btn-black flat"
            style={{ cursor: "default" }}
          >
            {data.display_name}
          </Button>
        );
      })}
    </ButtonWrapper>
  );
};

const navigateToProductDetails = (history, data) => {
  const categoryUrl =
    data.category_name === "apparels" || data.category_name === "Apparels"
      ? "apparel"
      : data.category_name === "handbags"
      ? "luxury"
      : data.category_name;
  history.push(
    `/${categoryUrl}/${data.product_variant_id}/${data.product_variant.slug}`
  );
};

const sneakerCondition = condition => {
  switch (condition) {
    case "BARU":
      return "Brand New";
    case "BEKAS":
      return "Used";
    case "PRISTINE":
      return "Pristine";
    case "GOOD":
      return "Good";
    case "WELL_USED":
      return "Well Used";
    case "LIKE_NEW":
      return "Like New";
    case "VINTAGE":
      return "Vintage";
    default:
      return "Brand New";
  }
};

const handbagCondition = data => {
  return detailHandbagCondition(data);
};

const detailHandbagCondition = data => {
  const condition = data
    .filter(item => item.value)
    .map(item => item.display_name)
    .join(" / ");

  return condition;
};

const accessories = condition => {
  if (condition === true) {
    return "Missing Accessories";
  } else {
    return "Complete Accessories";
  }
};

const boxHandbag = value => {
  if (value === true) {
    return "";
  } else {
    return "Missing Box";
  }
};

const dustBag = value => {
  if (value === true) {
    return "";
  } else {
    return "KA Dust Bag";
  }
};

const ModalHistorySell = props => {
  const { sale_product } = props.dataSale;

  const selisih =
    parseInt(
      props.dataSale.sale_product && props.dataSale.sale_product.lowest_ask
    ) - parseInt(props.dataSale.seller_price);

  const percentage = (selisih / parseInt(props.dataSale.seller_price)) * 100;

  const stringPercentage = percentage
    .toFixed(2)
    .toString()
    .replace(/-/, "");

  const category = sale_product && sale_product.category_name;
  const uniqueDefects =
    sale_product && sale_product === null
      ? []
      : _.uniqBy(sale_product && sale_product.defects, "name");
  const dustBagCondition = uniqueDefects
    ? uniqueDefects.find(a => a.name === "DUST_BAG")
    : {};
  const boxCondition = uniqueDefects
    ? uniqueDefects.find(a => a.name === "BOX")
    : {};
  const onErrorImg = e => {
    e.target.src = emptyImage(category);
  };
  const hide_box_info =
    props.userSell &&
    props.userSell.product_variant &&
    props.userSell.product_variant.hide_box_info;
  const luxuryDetailArr = [
    sneakerCondition(sale_product && sale_product.sneakers_condition),
    accessories(sale_product && sale_product.missing_accessories),
    dustBag(dustBagCondition),
    hide_box_info ? "" : boxHandbag(boxCondition),
    sale_product && sale_product.sneakers_defects
      ? handbagCondition(uniqueDefects)
      : ""
  ];
  const luxuryDetail = luxuryDetailArr
    .filter(item => item !== "" && item !== "Missing Box")
    .map(item => item)
    .join(" / ");
  const isVintage = props.userSell && props.userSell.product_variant && props.userSell.product_variant.vintage;

  return (
    <Modal
      isOpen={props.isOpen}
      className="kick-modal detail-modal-history"
      toggle={props.onToggle}
    >
      <Container id="payment">
        <ModalHeader id="header-detail-sell">
          <div onClick={props.onToggle}>
            <KickImage src={CloseIcon} alt="" />
          </div>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <div className="wrapper-image">
                <KickImage
                  src={
                    sale_product && sale_product.image_url
                      ? getCloudImageUrl(
                          sale_product && sale_product.image_url,
                          400
                        )
                      : emptyImage(category)
                  }
                  alt={sale_product && sale_product.display_name}
                  onError={e => onErrorImg(e)}
                />
              </div>
              <div className="wrapper-image title">
                <span>
                  {normalizeBrand(sale_product && sale_product.brand_name)}
                </span>
                <span
                  onClick={() =>
                    navigateToProductDetails(props.history, sale_product)
                  }
                >
                  {sale_product && sale_product.display_name}
                </span>
                <span>{sale_product && sale_product.SKU}</span>
              </div>
            </Col>
          </Row>
          {
            isVintage?
            <Row style={{ justifyContent: "center" }}>
              <ButtonWrapper isVintage={true}>
                <Button className="btn-black flat">
                    US {sale_product && sale_product.size.US}
                </Button>
                <Button className="btn-black flat">
                    Vintage
                </Button>
              </ButtonWrapper>
            </Row>
            :
            <Row style={{ justifyContent: "center" }}>
              {category === "handbags" ? (
                <div>
                  <span>{luxuryDetail}</span>
                </div>
              ) : category === "sneakers" ? (
                <ButtonWrapper hide_box_info={hide_box_info}>
                  <Button className="btn-black flat">
                    US {sale_product && sale_product.size.US}
                  </Button>
                  <Button className="btn-black flat">
                    {infoString(sale_product && sale_product.sneakers_condition)}
                  </Button>
                  {!hide_box_info && (
                    <Button className="btn-black flat">
                      {infoString(sale_product && sale_product.box_condition)}
                    </Button>
                  )}
                  <Button className="btn-black flat">
                    {accessoriesCondition(
                      sale_product && sale_product.missing_accessories
                    )}
                  </Button>
                </ButtonWrapper>
              ) : (
                defectCondition(
                  props.userSell && props.userSell.sneakers_defect,
                  props.userSell,
                  sale_product
                )
              )}
            </Row>
          }
          <Row>
            <Col xs={7}>
              <div className="wrapper-price">
                <span>Price Sold</span>
                <TextRupiah
                  prefix="IDR. "
                  value={props.dataSale.seller_price}
                  color="black"
                  bold={true}
                />
              </div>
            </Col>
            <Col xs={5}>
              <Row>
                <Col xs={5}>
                  <div className="wrapper-price">
                    <span>Current Lowest Ask</span>
                    <TextRupiah
                      prefix="IDR. "
                      value={
                        props.dataSale.sale_product &&
                        props.dataSale.sale_product.lowest_ask
                      }
                      color="black"
                      bold={true}
                    />
                  </div>
                </Col>
                <Col xs={7}>
                  <span
                    className={classNames({
                      "fa fa-angle-up text-success": percentage > 0,
                      "fa fa-angle-down text-success": percentage < 0
                    })}
                  />
                  <span>{stringPercentage}%</span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs={7}>
              <div className="wrapper-price">
                <span>Date Listed</span>
                <span>
                  {moment(props.userSell && props.userSell.approved_at).format(
                    "DD/MM/YYYY"
                  )}
                </span>
              </div>
            </Col>
            <Col xs={5}>
              <div className="wrapper-price">
                <span>Date Sold</span>
                <span>
                  {moment(props.dataSale.created_at).format("DD/MM/YYYY")}
                </span>
              </div>
            </Col>
          </Row>
          <Row>
            {props.dataSale.completed === 1 ? (
              <div className="status-history-sell">
                <span>PROCESS COMPLETED!</span>
              </div>
            ) : (
              <div className="status-history-sell failed">
                <span>PROCESS FAILED!</span>
              </div>
            )}
          </Row>
          <Row>
            <Col>
              <span>
                Please consistently check your emails and notifications to
                receive any informations regarding your package.
              </span>
            </Col>
          </Row>
        </ModalBody>
      </Container>
    </Modal>
  );
};

const infoString = data => {
  switch (data) {
    case SEMPURNA[0]:
      return SEMPURNA[2];
    case CACAT[0]:
      return CACAT[1];
    case NO_BOX[0]:
      return NO_BOX[1];
    case BARU[0]:
      return BARU[2];
    case BEKAS[0]:
      return BEKAS[2];
    case APPROVED:
      return LISTING[0];
    case SUSPEND:
      return LISTING[1];
    case DRAFT[0]:
      return DRAFT[1];
    case MORE_INFO[0]:
      return MORE_INFO[1];
    case CANCELLED[0]:
      return CANCELLED[1];
    case WAIT_CONFIRM[0]:
      return WAIT_CONFIRM[1];
    case WAIT_CONSIGN[0]:
      return WAIT_CONSIGN[1];
    case UNDER_REVIEW[0]:
      return UNDER_REVIEW[1];
    case REJECTED[0]:
      return REJECTED[1];

    default:
      return ADMINISTRATOR;
  }
};

const accessoriesCondition = data => {
  switch (data) {
    case 0:
      return "Complete Accessories";
    case 1:
      return "Missing Accessories";

    default:
      return ADMINISTRATOR;
  }
};

const ButtonWrapper = styled.div`
  display: grid;
  flex-wrap: wrap;
  grid-template-columns: ${props =>
    props.hide_box_info ? "1fr 1fr 1fr" : props.isVintage? "1fr 1fr" : "1fr 1fr 1fr 1fr"};
  grid-column-gap: 0.5rem;
`;

ModalHistorySell.propTypes = {
  imagesVariant: propTypes.array,
  onData: propTypes.object
};

ModalHistorySell.defaultProps = {
  imagesVariant: Array.from(Array(7).keys())
};

export default ModalHistorySell;
